import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash'
import {reduxForm, formValueSelector} from 'redux-form'
import Slide from '@material-ui/core/Slide'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import CopyToClipboard from 'react-copy-to-clipboard';
import ContentCopy from '@material-ui/icons/ContentCopy';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import DefaultCheckbox from '@material-ui/core/Checkbox';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';
import Textarea from '../../../../../uis/form/textarea';
import Number from '../../../../../uis/form/number';
import Select from '../../../../../uis/form/select'
import Datetime from '../../../../../uis/form/datetime'
import Checkbox from '../../../../../uis/form/checkbox'
import Upload from '../../../../../uis/form/idCardUpload'
import * as tip from '../../../../../uis/tip/reduces'
import dateFormat from '../../../../../util/dateFormat'


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    table: {
        minWidth: 700,
    },
    dialog: {
        maxWidth: 900
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit * 2
    },
    doubleTextField: {
        width: (300 * 2) + (theme.spacing.unit * 4),
        margin: theme.spacing.unit * 2
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    tableCell: {
        padding: '4px 28px 4px 12px'
    },
    more: {
        display: 'inline-block',
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
    showMe: {
        marginLeft: theme.spacing.unit * 2
    }
})

const validate = values => {
    const errors = {}
    
    if (!values.aliwangwang) {
        errors.aliwangwang = '必填'
    }
    
    if (!values.phone) {
        errors.phone = '必填'
    }
    
    if (!values.email) {
        errors.email = '必填'
    } else if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(values.email)) {
        errors.email = '格式不正确';
    }
    if (values.domain && values.domain.indexOf('www.') === 0) {
        errors.domain = '格式不正确, 不要带www';
    }
    if (values.isNeedBuyDomain  === undefined) {
        errors.isNeedBuyDomain = '必填'
    }
    if (values.isNeedBuyDomain && (values.domainMoney === undefined || +values.domainMoney === 0)) {
        errors.domainMoney = '必填, 请填写真实的域名费用'
    }

    if (values.isNeedBuyDomain && !values.cidType) {
        errors.cidType = '必填'
    }
    if (values.isNeedBuyDomain && !values.attachmentUrl) {
        errors.attachmentUrl = '必填'
    }

    if (!values.customerPlan) {
        errors.customerPlan = '必填'
    }

    if (values.customerPlan && _.includes(['H5企业(不带服务器)500', 'H5商城(不带服务器)750'], values.customerPlan)) {
        if (!values.customerFtpUrl) {
            errors.customerFtpUrl = '必填'
        }
        if (!values.customerFtpName) {
            errors.customerFtpName = '必填'
        }
        if (!values.customerFtpPassword) {
            errors.customerFtpPassword = '必填'
        }
    }

    if (!values.buyYear) {
        errors.buyYear = '必填'
    }
    if (!values.templateNumber) {
        errors.templateNumber = '必填'
    }
    if (values.templateNumber && !values.templateNumber.startsWith('H')) {
        errors.templateNumber = '模板编号必须以H开头';
    }
    
    
    if (!values.orderTime) {
        errors.orderTime = '必填'
    }
    if (values.orderMoney === undefined) {
        errors.orderMoney = '必填'
    }
    if (values.isNeedDecoration === undefined) {
        errors.isNeedDecoration = '必填'
    }
    if (values.isNeedDecoration && values.decorationMoney === undefined) {
        errors.decorationMoney = '必填'
    }
    if (!values.status) {
        errors.status = '必填'
    }
    if (values.isAuto  === undefined) {
        errors.isAuto = '必填'
    }
    if (!values.refundReason) {
        errors.refundReason = '必填';
    }
    if (values.refundMoney === undefined) {
        errors.refundMoney = '必填';
    }
    if (values.isRefundDomain === undefined) {
        errors.isRefundDomain = '必填';
    }
    if (values.isRefundWangzhan === undefined) {
        errors.isRefundWangzhan = '必填';
    }
    return errors
}

function Transition(props) {
    return <Slide {...props} direction="up" />
}
class AddDialog extends React.Component {
    handleStatus(e) {
        const {change} = this.props;
        if (e.target.value !== '新增') {
            change('isAuto', false)
        }
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, isNeedBuyDomain, isNeedDecoration, customerPlan, status} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullScreen
            TransitionComponent={Transition}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={() => dispatch({type: actions.HIDE_MODAL})}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            新增建站盒子订单
                        </Typography>
                        <Button color="inherit" type="submit" disabled={pristine || submitting}>
                            确定
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.dialogContent}>
                    <div>
                        <Text name="aliwangwang" label="客户旺旺号" placeholder="请输入客户旺旺号" className={classes.textField} required={true}/>
                        <Text name="phone" label="客户手机号" placeholder="请输入客户手机号" className={classes.textField} required={true}/>
                    </div>
                    <div>
                        <Text name="email" label="客户邮箱" placeholder="请输入客户邮箱" className={classes.textField} required={true}/>
                        <Select name="isNeedBuyDomain" label="是否需要购买域名" placeholder="请输入是否需要购买域名" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Text name="domain" label="客户域名" placeholder="请输入客户域名" className={classes.textField} required={isNeedBuyDomain}/>
                        <Number name="domainMoney" label="域名费用" placeholder="请查询域名费用后填写" className={classes.textField} required={isNeedBuyDomain}/>
                    </div>
                    <div>
                        <Select name="cidType" label="证件类型" placeholder="请输入证件类型" className={classes.textField} required={isNeedBuyDomain} data={[{"name":"营业执照","value":"营业执照"},{"name":"身份证","value":"身份证"}]}/>
                        <Upload name="attachmentUrl" id="attachmentUrl" label="身份证或者营业执照" placeholder="请输入身份证或者营业执照" className={classes.textField} required={isNeedBuyDomain}/>
                    </div>
                    <div>
                        <Select name="customerPlan" label="客户选择套餐" placeholder="请输入客户选择套餐" className={classes.textField} required={true} data={[{"name":"H5企业版550","value":"H5企业版550"},{"name":"H5商城850","value":"H5商城850"},{"name":"H5企业(不带服务器)500","value":"H5企业(不带服务器)500"},{"name":"H5商城(不带服务器)750","value":"H5商城(不带服务器)750"},{"name":"H5企业(带小程序)800","value":"H5企业(带小程序)800"},{"name":"H5商城(带小程序)1450","value":"H5商城(带小程序)1450"}]}/>
                        <Number name="buyYear" label="购买年限" placeholder="请输入购买年限" className={classes.textField} required={true}/>
                    </div>
                    {(customerPlan === 'H5企业(不带服务器)500' || customerPlan === 'H5商城(不带服务器)750') && <div>
                        <Text name="customerFtpUrl" label="FTP地址" placeholder="请输入FTP地址" className={classes.textField} style={{width: 200, marginLeft: 16, marginRight: 8}} required={true}/>
                        <Text name="customerFtpName" label="FTP用户名" placeholder="请输入FTP用户名" className={classes.textField} style={{width: 200, marginLeft: 8, marginRight: 8}} required={true}/>
                        <Text name="customerFtpPassword" label="FTP密码" placeholder="请输入FTP密码" className={classes.textField} style={{width: 200, marginLeft: 8, marginRight: 16}} required={true}/>
                    </div>}
                    <div>
                        <Datetime name="orderTime" label="下单日期" placeholder="请输入下单日期" className={classes.textField} required={true}/>
                        <Number name="orderMoney" label="套餐金额" placeholder="请输入下单金额" className={classes.textField} required={true}/>
                    </div>
                    <div>
                        <Select name="isNeedDecoration" label="是否需要装修" placeholder="请输入是否需要装修" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Number name="decorationMoney" label="装修金额" placeholder="请输入装修金额" className={classes.textField} required={isNeedDecoration}/>
                    </div>
                    <div>
                        <Text name="templateNumber" label="模板编号" placeholder="请输入模板编号" className={classes.textField} required={true}/>
                        <Datetime name="sendEmailTime" type="datetime-local" label="邮件发送日期" placeholder="请输入下单日期" className={classes.textField} required={true}/>
                    </div>
                    <div>
                        <Select name="status" label="状态" placeholder="请输入状态" className={classes.textField} required={true} data={[{"name":"待付款","value":"待付款"}, {"name":"授权码","value":"授权码"}, {"name":"续费","value":"续费"}, {"name":"装修","value":"装修"}, {"name":"多注册域名","value":"多注册域名"}, {"name":"更换套餐","value":"更换套餐"}, {"name":"新增","value":"新增"}]} onChange={(e) => this.handleStatus(e)}/>
                        {status === '新增' && <Select name="isAuto" label="是否软件自动" placeholder="请输入是否软件自动" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>}
                    </div>
                    <div className={classes.doubleTextField}>
                        <Textarea name="preSaleRemarks" label="售前备注" placeholder="请输入售前备注" className={classes.textField} style={{width: "100%", marginLeft: 0, marginRight: 0}} required={false}/>
                    </div>
                    
                </DialogContent>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, isNeedBuyDomain, isNeedDecoration, permissionMap} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullScreen
            TransitionComponent={Transition}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={() => dispatch({type: actions.HIDE_MODAL})}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                        {showModal.disabled ? '查看' : '修改'}建站盒子订单
                        </Typography>
                        {!showModal.disabled && <Button color="inherit" type="submit" disabled={pristine || submitting}>
                            确定
                        </Button>}
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.dialogContent}>
                    <div>
                        <Text name="aliwangwang" label="客户旺旺号" placeholder="请输入客户旺旺号" className={classes.textField} required={true} disabled={showModal.disabled}/>
                        <Text name="phone" label="客户手机号" placeholder="请输入客户手机号" className={classes.textField} required={true} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Text name="email" label="客户邮箱" placeholder="请输入客户邮箱" className={classes.textField} required={true} disabled={showModal.disabled}/>
                        <Select name="isNeedBuyDomain" label="是否需要购买域名" placeholder="请输入是否需要购买域名" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Text name="domain" label="客户域名" placeholder="请输入客户域名" className={classes.textField} required={isNeedBuyDomain} disabled={showModal.disabled}/>
                        <Number name="domainMoney" label="域名费用" placeholder="请输入域名费用" className={classes.textField} required={isNeedBuyDomain} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Select name="cidType" label="证件类型" placeholder="请输入证件类型" className={classes.textField} required={isNeedBuyDomain} data={[{"name":"营业执照","value":"营业执照"},{"name":"身份证","value":"身份证"}]} disabled={showModal.disabled}/>
                        <Upload name="attachmentUrl" id="attachmentUrl" label="身份证或者营业执照" placeholder="请输入身份证或者营业执照" className={classes.textField} required={isNeedBuyDomain} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Select name="customerPlan" label="客户选择套餐" placeholder="请输入客户选择套餐" className={classes.textField} required={true} data={[{"name":"H5企业版550","value":"H5企业版550"},{"name":"H5商城850","value":"H5商城850"},{"name":"H5企业(不带服务器)500","value":"H5企业(不带服务器)500"},{"name":"H5商城(不带服务器)750","value":"H5商城(不带服务器)750"},{"name":"H5企业(带小程序)800","value":"H5企业(带小程序)800"},{"name":"H5商城(带小程序)1450","value":"H5商城(带小程序)1450"}]} disabled={showModal.disabled}/>
                        <Number name="buyYear" label="购买年限" placeholder="请输入购买年限" className={classes.textField} required={true} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Datetime name="orderTime" label="下单日期" placeholder="请输入下单日期" className={classes.textField} required={true} disabled={showModal.disabled}/>
                        <Number name="orderMoney" label="套餐金额" placeholder="请输入下单金额" className={classes.textField} required={true} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Select name="isNeedDecoration" label="是否需要装修" placeholder="请输入是否需要装修" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]} disabled={showModal.disabled}/>
                        <Number name="decorationMoney" label="装修金额" placeholder="请输入装修金额" className={classes.textField} required={isNeedDecoration} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Text name="templateNumber" label="模板编号" placeholder="请输入模板编号" className={classes.textField} required={true} disabled={showModal.disabled}/>
                        <Datetime name="sendEmailTime" type="datetime-local" label="邮件发送日期" placeholder="请输入下单日期" className={classes.textField} required={true} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Text name="customerAdminUrl" label="客户登录后台" placeholder="请输入客户登录后台" className={classes.textField} disabled={showModal.disabled}/>
                        <Text name="customerFtpUrl" label="FTP地址" placeholder="请输入FTP地址" className={classes.textField} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Text name="customerFtpName" label="FTP用户名" placeholder="请输入FTP用户名" className={classes.textField} disabled={showModal.disabled}/>
                        <Text name="customerFtpPassword" label="FTP密码" placeholder="请输入FTP密码" className={classes.textField} disabled={showModal.disabled}/>
                    </div>
                    <div>
                        <Select name="isAuto" label="是否软件自动" placeholder="请输入是否软件自动" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]} disabled={showModal.disabled}/>
                        <Textarea name="preSaleRemarks" label="售前备注" placeholder="请输入售前备注" className={classes.textField} required={false} disabled={showModal.disabled}/>
                    </div>
                    {permissionMap['建站盒子订单_退款'] && <div className={classes.doubleTextField}>
                        <Select name="status" label="状态" placeholder="请输入状态" className={classes.textField} style={{margin: 0}} data={[{"name":"待付款","value":"待付款"}, {"name":"授权码","value":"授权码"}, {"name":"续费","value":"续费"}, {"name":"装修","value":"装修"}, {"name":"多注册域名","value":"多注册域名"}, {"name":"更换套餐","value":"更换套餐"}, {"name":"新增","value":"新增"},{"name":"域名注册中","value":"域名注册中"},{"name":"域名模板注册中","value":"域名模板注册中"},{"name":"建站中","value":"建站中"},{"name":"发送邮件中","value":"发送邮件中"},{"name":"等待域名解析","value":"等待域名解析"},{"name":"域名解析中","value":"域名解析中"},{"name":"等待域名所有人变更","value":"等待域名所有人变更"},{"name":"域名所有人变更中","value":"域名所有人变更中"},{"name":"完成","value":"完成"},{"name":"退款中","value":"退款中"},{"name":"退款审核","value":"退款审核"},{"name":"退款完成","value":"退款完成"},{"name":"错误","value":"错误"}]} disabled={showModal.disabled}/>
                    </div>}
                </DialogContent>
            </form>
        </Dialog>)
    }
}

class RefundDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.refund}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Checkbox name="isRefundDomain" label="是否退款域名" className={classes.textField} required={true} />
                    <Checkbox name="isRefundWangzhan" label="是否退款网站" className={classes.textField} required={true} />
                    <Number name="refundMoney" label="退款金额" placeholder="请输入退款金额" className={classes.textField} required={true}/>                   
                    <Textarea name="refundReason" label="退款原因" placeholder="请输入退款原因" className={classes.textField} required={true}/>
                    <Text name="status" label="状态" placeholder="退款中" className={classes.textField} readOnly={true}/>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

class FlowDialog extends Component {
    render() {
        const {dispatch,showModal, classes, flowDetail: {list}} = this.props
        return (<Dialog
            open={showModal.flow}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
            maxWidth={"md"}
            scroll={"paper"}
        >
            <DialogContent>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>执行人</TableCell>
                            <TableCell>执行时间</TableCell>
                            <TableCell>执行状态</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list.map(row => {
                            return (
                                <TableRow key={row.id}>
                                    <TableCell>{row.optAccountName}</TableCell>
                                    <TableCell>{dateFormat(new Date(row.createTime))}</TableCell>
                                    <TableCell>{row.status}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </DialogContent>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => {
        const selector = formValueSelector('orderJzhzAddForm')
        return {
            initialValues: {
                isAuto: false,
                orderTime: dateFormat(new Date(), 'yyyy-MM-dd'),
                sendEmailTime: dateFormat(new Date(Date.now() + (6 * 3600 * 1000)), 'yyyy-MM-ddTHH:mm')
            },
            isNeedBuyDomain: selector(state, 'isNeedBuyDomain'),
            isNeedDecoration: selector(state, 'isNeedDecoration'),
            customerPlan: selector(state, 'customerPlan'),
            status: selector(state, 'status')
        }
    },
)(reduxForm({
    form: 'orderJzhzAddForm',
    validate
})(AddDialog))

const UpdateFormDialog = connect(
    state => {
        const selector = formValueSelector('orderJzhzUpdateForm')
        return {
            initialValues: {
                ...state.orderJzhz.detail, 
                orderTime: dateFormat(new Date(state.orderJzhz.detail.orderTime), 'yyyy-MM-dd'), 
                sendEmailTime: dateFormat(new Date(state.orderJzhz.detail.sendEmailTime), 'yyyy-MM-ddTHH:mm')
            },
            permissionMap: state.auth.user.permissionMap,
            isNeedBuyDomain: selector(state, 'isNeedBuyDomain'),
            isNeedDecoration: selector(state, 'isNeedDecoration')
        }
    },
  )(reduxForm({
    form: 'orderJzhzUpdateForm',
    validate
})(UpdateDialog))

const RefundFormDialog = connect(
    state => ({
      initialValues: {...state.orderJzhz.detail, status: '退款中'}
    }),
  )(reduxForm({
    form: 'orderJzhzRefundForm',
    validate
})(RefundDialog))

class OrderJzhz extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
        dispatch(actions.getStatusDetail())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target ? e.target.value : e})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal, statusDeatial} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['建站盒子订单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                        <FormControlLabel
                            control={
                                <DefaultCheckbox
                                    checked={query.isOnlyShowMe}
                                    onChange={(e) => {
                                        this.changeQuery(!query.isOnlyShowMe, 'isOnlyShowMe');
                                        dispatch(actions.getStatusDetail())
                                    }}
                                    value={query.isOnlyShowMe}
                                />
                            }
                            className={classes.showMe}
                            label={"只显示与我相关"}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            select
                            label="选择筛选条件"
                            margin="normal"
                            style={{minWidth: 200}}
                            onChange={(event) => this.handleFiltersClick(event.target.value)}
                        >
                            {filterList.filter(item => !item.isShow).map((item, index) => {
                                return (
                                    <MenuItem
                                        key={index}
                                        value={item.value}
                                    >
                                        {item.name}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid container spacing={8} alignItems="baseline">
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                hideCancelBtn={item.hideCancelBtn}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Grid container spacing={8}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup
                            name="status"
                            className={classes.group}
                            value={query.status}
                            onChange={(e) => this.changeQuery(e,'status')}
                        >
                            <FormControlLabel value="" control={<Radio />} label={<p>全部<span style={{color: 'red'}}>（{statusDeatial['全部'] || 0}）</span></p>} />
                            {statusDeatial['待付款'] && <FormControlLabel value="待付款" control={<Radio />} label={<p>待付款<span style={{color: 'red'}}>（{statusDeatial['待付款']}）</span></p>} />}
                            {statusDeatial['授权码'] && <FormControlLabel value="授权码" control={<Radio />} label={<p>授权码<span style={{color: 'red'}}>（{statusDeatial['授权码']}）</span></p>} />}
                            {statusDeatial['续费'] && <FormControlLabel value="续费" control={<Radio />} label={<p>续费<span style={{color: 'red'}}>（{statusDeatial['续费']}）</span></p>} />}
                            {statusDeatial['装修'] && <FormControlLabel value="装修" control={<Radio />} label={<p>装修<span style={{color: 'red'}}>（{statusDeatial['装修']}）</span></p>} />}
                            {statusDeatial['多注册域名'] && <FormControlLabel value="多注册域名" control={<Radio />} label={<p>多注册域名<span style={{color: 'red'}}>（{statusDeatial['多注册域名']}）</span></p>} />}
                            {statusDeatial['更换套餐'] && <FormControlLabel value="更换套餐" control={<Radio />} label={<p>更换套餐<span style={{color: 'red'}}>（{statusDeatial['更换套餐']}）</span></p>} />}
                            {statusDeatial['新增'] && <FormControlLabel value="新增" control={<Radio />} label={<p>新增<span style={{color: 'red'}}>（{statusDeatial['新增']}）</span></p>} />}
                            {statusDeatial['域名注册中'] && <FormControlLabel value="域名注册中" control={<Radio />} label={<p>域名注册中<span style={{color: 'red'}}>（{statusDeatial['域名注册中']}）</span></p>} />}
                            {statusDeatial['域名模板注册中'] && <FormControlLabel value="域名模板注册中" control={<Radio />} label={<p>域名模板注册中<span style={{color: 'red'}}>（{statusDeatial['域名模板注册中']}）</span></p>} />}
                            {statusDeatial['建站中'] && <FormControlLabel value="建站中" control={<Radio />} label={<p>建站中<span style={{color: 'red'}}>（{statusDeatial['建站中']}）</span></p>} />}
                            {statusDeatial['发送邮件中'] && <FormControlLabel value="发送邮件中" control={<Radio />} label={<p>发送邮件中<span style={{color: 'red'}}>（{statusDeatial['发送邮件中']}）</span></p>} />}
                            {statusDeatial['等待域名解析'] && <FormControlLabel value="等待域名解析" control={<Radio />} label={<p>等待域名解析<span style={{color: 'red'}}>（{statusDeatial['等待域名解析']}）</span></p>} />}
                            {statusDeatial['域名解析中'] && <FormControlLabel value="域名解析中" control={<Radio />} label={<p>域名解析中<span style={{color: 'red'}}>（{statusDeatial['域名解析中']}）</span></p>} />}
                            {statusDeatial['等待域名所有人变更'] && <FormControlLabel value="等待域名所有人变更" control={<Radio />} label={<p>等待域名所有人变更<span style={{color: 'red'}}>（{statusDeatial['等待域名所有人变更']}）</span></p>} />}
                            {statusDeatial['完成'] && <FormControlLabel value="完成" control={<Radio />} label={<p>完成<span style={{color: 'red'}}>（{statusDeatial['完成']}）</span></p>} />}
                            {statusDeatial['退款中'] && <FormControlLabel value="退款中" control={<Radio />} label={<p>退款中<span style={{color: 'red'}}>（{statusDeatial['退款中']}）</span></p>} />}
                            {statusDeatial['退款审核'] && <FormControlLabel value="退款审核" control={<Radio />} label={<p>退款审核<span style={{color: 'red'}}>（{statusDeatial['退款审核']}）</span></p>} />}
                            {statusDeatial['退款完成'] && <FormControlLabel value="退款完成" control={<Radio />} label={<p>退款完成<span style={{color: 'red'}}>（{statusDeatial['退款完成']}）</span></p>} />}
                            {statusDeatial['错误'] && <FormControlLabel value="错误" control={<Radio />} label={<p>错误<span style={{color: 'red'}}>（{statusDeatial['错误']}）</span></p>} />}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableCell}>客户信息</TableCell>
                                <TableCell className={classes.tableCell}>域名信息</TableCell>
                                <TableCell className={classes.tableCell}>套餐信息</TableCell>
                                <TableCell className={classes.tableCell}>装修信息</TableCell>
                                <TableCell className={classes.tableCell}>状态</TableCell>
                                <TableCell className={classes.tableCell}>后台信息</TableCell>
                                <TableCell>操作</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell className={classes.tableCell}>
                                            <p>ID: J{row.id}</p>
                                            <p>来源: {(row.referDomain || '').indexOf('zhigui') !== -1 ? '纸圭' : '双德'}</p>
                                            <p>旺旺号: {row.aliwangwang}</p>
                                            <p>手机号: {row.phone}</p>
                                            <p>邮箱: {row.email}</p>
                                            {row.cidType && <p>证件类型: {row.cidType}</p>}
                                            {row.attachmentUrl && <p>客户证件: <a href={`${row.attachmentUrl}`} target="_blank">查看</a></p>}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>客户域名: {row.domain}</p>
                                            <p>是否购买: {row.isNeedBuyDomain ? '是' : '否'}</p>
                                            <p>域名费用: {row.domainMoney}</p>
                                            {row.domainCard && <p>域名证书: <a href={row.domainCard} target="_blank" download={`${row.domain}的证书.jpg`}>下载</a></p>}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>套餐: {row.customerPlan}</p>
                                            <p>年限: {row.buyYear}</p>
                                            <p>模板编号: {row.templateNumber}</p>
                                            <p>下单日期: {dateFormat(new Date(row.orderTime))}</p>
                                            <p>套餐金额: {row.orderMoney}</p>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>是否装修: {row.isNeedDecoration ? '是' : '否'}</p>
                                            <p>装修费用: {row.decorationMoney}</p>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>订单状态: {row.status}</p>
                                            {row.status === '错误' && <p>错误原因: {row.statusMessage}</p>}
                                            <p>创建人: {row.accountName}</p>
                                            <p>创建日期: {dateFormat(new Date(row.createTime))}</p>
                                            <p>是否软件自动: {row.isAuto ? '是' : '否'}</p>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {row.customerAdminUrl && <p>
                                                客户登录后台: <a href={`${row.customerAdminUrl}`} target="_blank">点击访问</a>
                                                <Tooltip title="点我复制">
                                                    <CopyToClipboard text={row.customerAdminUrl} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                    </CopyToClipboard>
                                                </Tooltip>
                                            </p>}
                                            {row.customerFtpUrl && <p>
                                                FTP地址: {row.customerFtpUrl}
                                                    <CopyToClipboard text={row.customerFtpUrl} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                    </CopyToClipboard>
                                            </p>}
                                            {row.customerFtpName && <p>
                                                FTP用户名: {row.customerFtpName}
                                                    <CopyToClipboard text={row.customerFtpName} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                    </CopyToClipboard>
                                            </p>}
                                            {row.customerFtpPassword && <p>
                                                FTP密码: {row.customerFtpPassword}
                                                    <CopyToClipboard text={row.customerFtpPassword} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                    </CopyToClipboard>
                                            </p>}
                                            {row.customerAdminUrl && <p>
                                                <CopyToClipboard text={`登录后台: ${row.customerAdminUrl}\nFTP地址: ${row.customerFtpUrl}\nFTP用户名: ${row.customerFtpName}\nFTP密码: ${row.customerFtpPassword}`}  onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <a href={`javascript:;`}>一键复制客户信息</a>
                                                </CopyToClipboard>
                                            </p>}
                                            {row.customerAdminUrl && <p><a href={`http://${row.id}.jzhz.xuansiwei.com/init.php`} target="_blank">一键登录</a></p>}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {permissionMap['建站盒子订单_查询'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(row.id, true))}>查看详情</a>}<br/><br/>
                                            {permissionMap['建站盒子订单_修改'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(row.id, false))}>修改</a>}<br/><br/>
                                            {permissionMap['建站盒子订单_删除'] && <a href={`javascript:;`} onClick={()=>dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}>删除</a>}<br/><br/>
                                            {permissionMap['建站盒子订单_退款'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showRefundModal(row.id))}>退款</a>}<br/><br/>
                                            {permissionMap['建站盒子订单_查询'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showFlowModal(row.id, true))}>查看订单流程</a>}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
                {showModal.refund && <RefundFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.flow && <FlowDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.orderJzhz,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(OrderJzhz))


// WEBPACK FOOTER //
// ./src/pages/home/routes/order_jzhz/components/list.js